<template>
  <span v-if="model.$diff" :path="model.$path">
    <span class="prev-value">{{model.$diff.$prevValue}}</span>
    <span class="new-value">{{model.$diff.$newValue}}</span>
  </span>

  <span v-else-if="model.$value">{{model.$value}}</span>
  <span v-else>
    <slot name="emptyValue">{{emptyValue}}</slot>
  </span>
</template>

<script>
export default {
  props: {
    model: Object,
    emptyValue: String
  }
};
</script>

